import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BtnGoBack from "../../components/common/btnGoBack";
import Loadding from "../../components/common/loadding";
import CountSend from "../../components/report/countSend";
import GenReportDoc3 from "../../components/report/reportDoc3/genReportDoc3";
import TitleReport from "../../components/report/titleReport";
import CountCourse from "../../components/schedule/setting/countCount";
import { Path } from "../../constants/enum/path.emum";
import curriculumService from "../../services/curriculum.service";
import scheduleService from "../../services/schedule.service";
type ParamType = {
  sche: string;
};
const ReportCurri = () => {
  // เอาไปดึงหลักสูตรที่เป็น typr === schedule.type
  const Param = useParams<ParamType>();
  const [sche, setSche] = useState<any>();
  const [curri, setCurri] = useState([]);
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      await scheduleService.getById(Number(Param.sche)).then((res) => {
        setSche(res.data);
        curriculumService.getByType(res.data.type).then((res: any) => {
          setCurri(res.data);
          setStatus(false);
        });
      });
    })();
  }, [Param.sche]);

  if (status) {
    return <Loadding />;
  }
  return (
    <>
      <div className="container">
        <TitleReport scheId={Number(Param.sche)} />
        <div className="row mt-3">
          <div className="col">
            {/* <h3 className="p-3 mb-4 bg-light rounded-4">
              <div className="row"> */}
            {/* <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหา"
                    aria-label="ค้นหา"
                  />
                </div> */}
            {/* <div className="col-2 d-grid">
                  <button type="button" className="btn btn-success text-white">
                    <i className="bi bi-folder-plus"></i> เพิ่ม
                  </button>
                </div> */}
            {/* </div>
            </h3> */}
            <h5 className="text-start mt-3">
              รายการหลักสูตร {sche.type === "tqf" ? "มคอ." : "อชว."} | RMUTI
              ทั้งหมด
            </h5>
            <table className="table table-hover table-responsive">
              <thead className="table-dark">
                <tr>
                  <th>ชื่อย่อ</th>
                  <th>ชื่อหลักสูตร</th>
                  <th>ระดับ</th>
                  <th>
                    จำนวนวิชาที่ต้อง {sche.type === "tqf" ? "มคอ." : "อชว."}3 |
                    R-1
                    {/* <CountCourse schedule={schedule} curri={d} /> */}
                  </th>
                  <th>จำนวนรายวิชาที่ส่งแล้ว</th>

                  {/* <th>ส่ง {schedule.type === "tqf" ? "มคอ." : "อชว."}3 แล้ว</th> */}
                  <th>Handle</th>
                </tr>
              </thead>
              <tbody>
                {curri.map((curri: any) => {
                  return (
                    <tr key={curri.id}>
                      <th scope="row">{curri.shortName}</th>
                      <td>{curri.name}</td>
                      <td>{curri.level}</td>
                      <td>
                        <CountCourse
                          schedule={Number(Param.sche)}
                          curri={curri}
                        />
                      </td>
                      <td>
                        <CountSend
                          scheId={Number(Param.sche)}
                          curriId={Number(curri.id)}
                        />
                      </td>
                      <td>
                        <Link
                          to={{
                            pathname: `${Path.REPORT}/${Param.sche}/${curri.id}`,
                          }}
                          type="button"
                          // className="btn btn-sm btn-outline-warning"
                          className="btn btn-sm btn-warning"
                        >
                          <i className="bi bi-file-earmark-text-fill"></i>
                          รายงานการส่งเอกสาร
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {/* <div className="row">
              <div className="col">
                ต้องแสดงข้อมูลว่าต้องส่งกี่วิชา และส่งแล้วกี่วิชา ในตาราง
              </div>
            </div> */}
            <div className="row">
              <div className="col">
                <GenReportDoc3 sche={Number(Param.sche)} />

                {/* <button className="btn  btn-primary">
                  รายงารการส่งเอกสาร GenPDF111 ตรงนี้สร้างใหม่
                </button> */}
              </div>
            </div>
            <BtnGoBack />
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportCurri;
